import { push } from 'react-router-redux';
import { submitIdentityDocument } from '../../helpers/api/verifications';
import { patch } from '../../helpers/api/pages';

const UPLOAD_DOCUMENT_REQUEST = 'UPLOAD_DOCUMENT_REQUEST';
const UPLOAD_DOCUMENT_SUCCESS = 'UPLOAD_DOCUMENT_SUCCESS';
const UPLOAD_DOCUMENT_FAILURE = 'UPLOAD_DOCUMENT_FAILURE';

const UPDATE_VERIFICATION_STATUS_REQUEST = 'UPDATE_VERIFICATION_STATUS_REQUEST';
const UPDATE_VERIFICATION_STATUS_SUCCESS = 'UPDATE_VERIFICATION_STATUS_SUCCESS';
const UPDATE_VERIFICATION_STATUS_FAILURE = 'UPDATE_VERIFICATION_STATUS_FAILURE';

export function uploadDocument(documentType, file) {
  return async (dispatch, getState) => {
    try {
      dispatch({
        type: UPLOAD_DOCUMENT_REQUEST,
        payload: { documentType, file },
      });

      const { page } = getState();
      const result = await submitIdentityDocument(page.id, documentType, file);

      if (result.verified) {
        dispatch({ type: UPLOAD_DOCUMENT_SUCCESS, payload: result });
        dispatch({
          type: 'UPDATE_SUCCESS',
          payload: { verificationStatus: 'DocumentVerificationPending' },
        });
        dispatch(push(`/${page.name}/dashboard`));
      } else if (result.message === 'approvalNeeded') {
        dispatch({
          type: UPLOAD_DOCUMENT_FAILURE,
          error: true,
          payload: result,
        });
        dispatch({
          type: 'UPDATE_SUCCESS',
          payload: { verificationStatus: 'UnverifiedAddress' },
        });
        dispatch(push(`/${page.name}/dashboard/address`));
      } else {
        dispatch({
          type: UPLOAD_DOCUMENT_FAILURE,
          error: true,
          payload: result,
        });
      }
    } catch (error) {
      dispatch({
        type: UPLOAD_DOCUMENT_FAILURE,
        error: true,
        payload: { message: 'serverError', error },
      });
    }
  };
}

function getRelativePath(verificationStatus) {
  switch (verificationStatus) {
    case 'UnverifiedPayment':
      return '/dashboard/payment';
    case 'UnverifiedDocument':
      return '/dashboard/identity';
    case 'UnverifiedAddress':
      return '/dashboard/address';
    default:
      return '';
  }
}

export function updateVerificationStatus(verificationStatus) {
  return async (dispatch, getState) => {
    try {
      dispatch({
        type: UPDATE_VERIFICATION_STATUS_REQUEST,
        payload: { verificationStatus },
      });

      const { page } = getState();
      await patch({ name: page.name, verificationStatus });

      dispatch({
        type: UPDATE_VERIFICATION_STATUS_SUCCESS,
        payload: { verificationStatus },
      });
      dispatch(push(`/${page.name}${getRelativePath(verificationStatus)}`));
    } catch (error) {
      dispatch({
        type: UPDATE_VERIFICATION_STATUS_FAILURE,
        error: true,
        payload: { error },
      });
    }
  };
}

export default function reducer(
  state = {
    serverErrorMessage: null,
  },
  action
) {
  switch (action.type) {
    case UPLOAD_DOCUMENT_REQUEST:
      return { ...state, isUploading: true, serverErrorMessage: null };
    case UPLOAD_DOCUMENT_SUCCESS:
      return { ...state, isUploading: false };
    case UPLOAD_DOCUMENT_FAILURE:
      return {
        ...state,
        isUploading: false,
        serverErrorMessage: action.payload.message,
      };
    case UPDATE_VERIFICATION_STATUS_REQUEST:
      return { ...state, isUpdatingStatus: true, error: null };
    case UPDATE_VERIFICATION_STATUS_SUCCESS:
      return { ...state, isUpdatingStatus: false };
    case UPDATE_VERIFICATION_STATUS_FAILURE:
      return { ...state, isUpdatingStatus: false, error: action.payload.error };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/modules/identityVerification.js